module.exports = __webpack_public_path__ + "img/home_logo.6361e419.png";